import React from 'react';
import Paper from '@material-ui/core/Paper';
import CircularProgress from "@material-ui/core/CircularProgress";

//css
import MainCss from './Main-css';
const useStyles = MainCss();

const content = (props) => {
    const classes = useStyles();
    const dataBase64 = `data:${props.state.tipo};base64,${props.state.data}`;
    return (
        <div className={classes.root}>
            <Paper className={classes.paper} align={'center'}>
                {props.state.isLoading &&
                    <div align="center">
                        <CircularProgress />
                    </div>
                }
                {!props.state.isLoading &&
                    <iframe src={dataBase64} className={classes.imagem}/>
                }
            </Paper>
        </div>
    );
};

export default content;